import PlusIcon from "@assets/icons/plus.svg";
import UploadIcon from "@assets/icons/upload.svg";
import { Collapse, Descriptions, Table } from "antd";
import { columns, shipmentOrders } from "./mock";
import { useState } from "react";
import { EMPTY_SHIPMENT } from "../../InventoryOverview/forms/utils";
import AddShipmentModal from "../../InventoryOverview/modals/ShipmentModals/AddShipmentModal";
import EditShipmentModal from "../../InventoryOverview/modals/ShipmentModals/EditShipmentModal";
import UploadCSVModal from "../../InventoryOverview/modals/UploadCSVModal";
import styles from "../styles.module.scss";

const { Panel } = Collapse;

const renderShipmentSummary = (pageData) => {
  const totalQty = pageData.reduce((sum, p) => sum + p.quantity, 0);
  return (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
      <Table.Summary.Cell index={1} />
      <Table.Summary.Cell index={2} />
      <Table.Summary.Cell index={3}>{totalQty}</Table.Summary.Cell>
    </Table.Summary.Row>
  );
};

export const ShipmentTab = () => {
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openAddMannual, setOpenAddMannual] = useState(false);

  return (
    <div className={styles.tabContent}>
      <div className={styles.header}>
        <p>Total {shipmentOrders.length} Shipment Orders</p>
        <div className={styles.buttons}>
          <button
            className={styles.blackButton}
            onClick={() => setOpenUploadModal(true)}
          >
            <img src={UploadIcon} alt="Upload" /> Upload CSV
          </button>
          <button
            className={styles.blackButton}
            onClick={() => setOpenAddMannual(true)}
          >
            <img src={PlusIcon} alt="Add" /> Add SO Mannualy
          </button>
        </div>
      </div>
      <Collapse
        defaultActiveKey={[shipmentOrders[0].soNumber]}
        accordion
        ghost
        className={styles.collapseContentStyle}
      >
        {shipmentOrders.map((so) => (
          <Panel
            key={so.soNumber}
            header={`SO: #${so.soNumber}`}
            className={styles.collapseLabelStyle}
          >
            <Descriptions
              className={styles.descriptionLabelItem}
              layout="vertical"
            >
              <Descriptions.Item label="Shipment Number">
                {so.shipmentNumber}
              </Descriptions.Item>
              <Descriptions.Item label="SO Status">
                {so.status}
              </Descriptions.Item>
              <Descriptions.Item label="Freight Method">
                ✈ {so.freightMethod}
              </Descriptions.Item>
              <Descriptions.Item label="Shipment Cost">
                {so.shipmentCost}
              </Descriptions.Item>
              <Descriptions.Item label="Issue Date">
                {so.issueDate}
              </Descriptions.Item>
              <Descriptions.Item label="Shipment Date">
                {so.shipmentDate}
              </Descriptions.Item>
              <Descriptions.Item label="Estimated Delivery Date">
                {so.estDeliveryDate}
              </Descriptions.Item>
              <Descriptions.Item label="Actual Delivery Date">
                {so.actDeliveryDate}
              </Descriptions.Item>
              <Descriptions.Item label="Destination">
                {so.destination}
              </Descriptions.Item>
              <Descriptions.Item label="Ship-from location">
                {so.shipFrom}
              </Descriptions.Item>
              <Descriptions.Item label="Purchase Order Number">
                {so.purchaseOrderNumber}
              </Descriptions.Item>
            </Descriptions>
            {so.products.length > 0 && (
              <Table
                columns={columns}
                dataSource={so.products}
                pagination={false}
                rowKey="asin"
                className={styles.table}
                summary={renderShipmentSummary}
              />
            )}
          </Panel>
        ))}
      </Collapse>
      <UploadCSVModal
        open={openUploadModal}
        onCancel={() => setOpenUploadModal(false)}
        title="Upload Purchase Orders"
        ManualModal={AddShipmentModal}
        EditModal={EditShipmentModal}
        onSaveData={() => setOpenUploadModal(false)}
        data={[EMPTY_SHIPMENT]}
      />
      <AddShipmentModal
        open={openAddMannual}
        onCancel={() => setOpenAddMannual(false)}
        onSaveData={() => setOpenAddMannual(false)}
      />
    </div>
  );
};
